import { GlobalDialogType } from '@/features/common/contexts/GlobalDialogs/global-dialog.type';
import React from 'react';

export type GlobalDialogsContextProps = {
  isOpen: boolean;
  dialog: GlobalDialogType | null;
  openDialog: (dialog: GlobalDialogType) => void;
  closeDialog: () => void;
};

export const GlobalDialogsContext =
  React.createContext<GlobalDialogsContextProps>({
    isOpen: false,
    dialog: null,
    openDialog: (_dialog: GlobalDialogType) => {},
    closeDialog: () => {}
  });
